<template>
    <van-config-provider :theme-vars="themeVars">
    <div class="van-hairline--surround">
         <van-cell-group inset border="false">
           <h3 style="padding-top: 1em;">{{ article.playerFilesVo.title }}</h3>
           <p class="textIndentation">{{ article.playerFilesVo.desc }}</p>
         </van-cell-group>
          <div class="video-center">
            <video id="player-container-id"  width="300" height="490" preload="auto" playsinline webkit-playsinline></video>
          </div>
          <br/>
          
      <div class="van-hairline--surround">
        <van-cell-group inset border="false">
          <p class="text3Indentation"><van-text-ellipsis :content="text" expand-text="展开" collapse-text="收起" /></p>
        </van-cell-group>
      </div>
         <p v-if="showQue" class="match">
            <van-notice-bar color="#EA6853" wrapable :scrollable="false">
              <strong>调研讨论(知晓率)</strong>
          </van-notice-bar>
          <br/>
          <van-cell-group inset>
            <van-slider v-model="value" bar-height="8px" disabled >
            <template #button>
               <div class="custom-button">{{ customValue }}</div>
            </template>
          </van-slider>
          </van-cell-group>
        
        </p>
     </div>
   </van-config-provider>
   <van-cell-group  v-if="showQue" inset>
              <van-notice-bar
                :theme-vars="themeVars"
                wrapable
                :scrollable="false">
                {{ article.playerFilesVo.queDesc }}
              </van-notice-bar>
              <van-cell>
                <van-radio-group v-model="article.playerFilesVo.ansCode">
                  <van-radio name="1" icon-size="24px">是</van-radio>
                  <br />
                  <van-radio name="0" icon-size="24px">否</van-radio>
                </van-radio-group>
              </van-cell>
            </van-cell-group>
          <div  v-if="showQue" style="margin: 16px;">
                  <van-button v-if="showButton" round block type="warning" @click="putArticleAns">
                      提交
                  </van-button>
                  <van-button v-else block type="warning" disabled >
                      已经提交
                  </van-button>
              </div>
  </template>
  <script>
  import {ref,reactive, onMounted } from 'vue';
  import TCPlayer from 'tcplayer.js';
  import 'tcplayer.js/dist/tcplayer.min.css';
  import { postUserLog } from '../../api/userlog'
  import {postArticleAns } from '../../api/article'
  import request from '../../utils/request';
  import { useRouter } from 'vue-router';
  export default {
   setup() {
    const value = ref(30);
    const customValue=ref('');
    const text =ref('');
     const themeVars = reactive({
       cellGroupBackground: '#F1F1F1',
     });
     const kpian = reactive({
       cellGroupBackground: '#AAAAAA',
     });
     const kpianawait = reactive({
       cellGroupBackground: '#F1F1F1',
     });
     const themeVars2 = reactive({
       cellGroupBackground: '#F1F1F1',
     });
     let player = reactive(null)
     const router = useRouter(); 
     const showQue =ref(false);
     const showButton =ref(false);
     const ulog = reactive({
        UserLog: {
          path: '',
        }
      });
      const oncePush = reactive({
        UserOncePush: {
          wxOpenId: '',
          templateId: '',
          action: '',
          scene: '',
        }
      })
      const article = reactive({
        playerFilesVo: {
          isWidth: '',
          title: '',
          messageId: '',
          fileID: '',
          psign: '',
          appID: '',
          licenseUrl: '',
          desc: '',
          queDesc: '',
          ansCode: '',
          ansCount: '',
          author: '',
        }
      });
      const putArticleAns=()=>{
        console.log(article.playerFilesVo);
        postArticleAns(article.playerFilesVo).then((res) =>{
            article.playerFilesVo=res.data.data;
            value.value=article.playerFilesVo.ansCount;
            showButton.value=false;
            customValue.value=article.playerFilesVo.ansCount+'%';
        })
      }
     onMounted(() => {
      console.log(router.currentRoute.value.params.reserved);
      request.get('/wxmanager/article/articleView', {
          params: {
            articleId: router.currentRoute.value.query.messageId
          }
        }).then((res) => {
          article.playerFilesVo=res.data.data;
          console.log(article.playerFilesVo);
        if(article.playerFilesVo.author!= null){
            text.value=article.playerFilesVo.author;
          }
        if( article.playerFilesVo.queDesc!= null){
            showQue.value=true;
        }
        if(article.playerFilesVo.ansCode == null){
            console.log(article.playerFilesVo.ansCode);
            showButton.value=true;
            value.value=0;
            customValue.value="";
        }else{
            value.value=article.playerFilesVo.ansCount;
            customValue.value=article.playerFilesVo.ansCount+'%';
        }
        player = TCPlayer('player-container-id',
         {
           fileID: article.playerFilesVo.fileID, // 请传入需要播放的视频 fileID（必须）
           appID: article.playerFilesVo.appID, // 请传入点播账号的 appID（必须）
           psign: article.playerFilesVo.psign,  
           licenseUrl: article.playerFilesVo.licenseUrl,
         });
       })
        ulog.UserLog.path = router.currentRoute.value.fullPath;
        console.log("当前页面路径=="+ulog.UserLog.path) 
        postUserLog(ulog.UserLog).then(() => {
           
          })
        })
     return {
       //fid,
       player,
       themeVars,
       oncePush,
       kpian,
       kpianawait,
       themeVars2,
       article,
       showQue,
       value,
       text,
       showButton,
       customValue,
       putArticleAns,
     }
   }
  }
  </script>
  <style scoped lang="scss">
  @import url("//imgcache.qq.com/open/qcloud/video/tcplayer/tcplayer.css");
  #app {
   font-family: Avenir, Helvetica, Arial, sans-serif;
   -webkit-font-smoothing: antialiased;
   -moz-osx-font-smoothing: grayscale;
   text-align: center;
   color: #2c3e50;
  }
  
  .textIndentation {
   text-align: left;
   text-indent: 2em;
   font-weight: bold;
   font-size: 14px;
   padding-top: 1em;
   padding-right: 1em;
   padding-bottom: 1em;
   padding-left: 1em;
   line-height:30px;
  }
  
  .text2Indentation {
   text-align: left;
   text-indent: 2em;
   font-weight: bold;
   font-size: 14px;
   padding-top: 1px;
   padding-right: 1em;
   padding-bottom: 1em;
   padding-left: 1em;
  }
  
  .match {
   text-align: left;
   text-indent: 1em;
   font-size: 14px;
  }
  
  .text3Indentation {
   text-align: left;
   font-weight: bold;
   font-size: 14px;
   padding-top: 1em;
   padding-right: 1em;
   padding-bottom: 1em;
   padding-left: 1em;
  }
  .video-center{
    display:flex;
    justify-content: center;
    align-items:center; 
  }
  .custom-button {
      width: 50px;
      color: #fff;
      font-size: 12px;
      line-height: 18px;
      text-align: center;
      background-color: var(--van-primary-color);
      border-radius: 100px;
    }
  </style>
  